// removed by extract-text-webpack-plugin
module.exports = {"container":"checkbox__container___3CSIJ","container--checked":"checkbox__container--checked___nHjxw"};


//////////////////
// WEBPACK FOOTER
// ./src/scss/components/common/checkbox.scss
// module id = 1301
// module chunks = 0